export default __webpack_public_path__ + "static/carousel-4-giuliana-c2ff9282c1b7fc21fa077270d11f01b3.png";